import { useState } from 'react'

// Arrow keys over a filtered list, for a search box that keeps focus. Nothing is highlighted until
// the first arrow, so the top row never looks pre-selected while the leader is still typing; Enter
// picks the highlighted row, or the only match left; Escape calls `onEscape` with the event.
export const useListKeyboardNav = (items, { onPick, onEscape }) => {
  const [ index, setIndex ] = useState(-1)
  // Clamped as the list shrinks under the highlight; -1 stays "none".
  const active = index < 0 ? -1 : Math.min(index, items.length - 1)

  const onKeyDown = (event) => {
    if (event.key === 'Escape') {
      onEscape(event)
      return
    }
    if (items.length === 0) { return }
    if (event.key === 'ArrowDown') {
      event.preventDefault()
      setIndex(active < 0 ? 0 : Math.min(active + 1, items.length - 1))
    } else if (event.key === 'ArrowUp') {
      event.preventDefault()
      setIndex(active <= 0 ? 0 : active - 1)
    } else if (event.key === 'Enter') {
      event.preventDefault()
      const pick = active >= 0 ? active : (items.length === 1 ? 0 : -1)
      if (pick >= 0) { onPick(items[pick]) }
    }
  }

  return { active, reset: () => setIndex(-1), onKeyDown }
}
